import React from 'react';
import CatalogProductFeed from '@components/catalog/catalog-product-feed/catalog-product-feed';
import { CatalogProduct } from '@interfaces/models/catalogProduct';
import { Product } from '@interfaces/models/product';

type CatalogListProps = {
  containerClsx?: React.CSSProperties | string;
  productType?: string;
  isLoading: boolean;
  products: Array<Product | CatalogProduct>;
  // CMS context for cms_content_click tracking
  cmsProps?: {
    sectionIdx?: string;
    contentTypeUid?: string;
    blockUid?: string;
    productType?: string;
    productFeedIndex?: string;
  };
};

const CatalogList: React.FC<CatalogListProps> = (props): React.JSX.Element => {
  const { containerClsx, productType, products, isLoading, cmsProps } = props;

  return (
    <CatalogProductFeed
      {...{ products, containerClsx, isLoading }}
      productCardProps={{
        pageType: 'cms_page',
        moduleType: productType,
        // Hotfix: For CMS LP non-slider product_feed catalog block, align with Sliders grid tracking by
        // forcing product_feed_category to 'catalog'. Sliders and PLP use their own
        // logic (including alertId-based categories); this path doesn't hit that code.
        productFeedCategory: 'catalog',
        cmsProps,
      }}
    />
  );
};

export default CatalogList;
